import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalEmployeeFunctionGroupsDbTableDefinition extends DbTableDefinition {
  tableName = 'local_employeeFunctionGroups';
  tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
     employeeid BIGINT(20),
     functiongroupid BIGINT(20),
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(62, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
